import { render, staticRenderFns } from "./BudgetPlanner.vue?vue&type=template&id=412a05da&"
import script from "./BudgetPlanner.vue?vue&type=script&lang=js&"
export * from "./BudgetPlanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports